import React, { useRef } from 'react';
import './questions.style.scss';
import { QuestionTypes, ReduxState } from 'interface';
import { __SLPQuestionType, __QuestionSLPRef } from './questions.interface';
import { connect, ConnectedProps } from 'react-redux';
import SLPTextQuestion from './questionsTypes/text/text.index';
import SLPNumberQuestion from './questionsTypes/number/number.index';
import SLPEmailQuestion from './questionsTypes/email/email.index';
import SLPWebsiteQuestion from './questionsTypes/website/website.index';
import SLPNPSQuestion from './questionsTypes/nps/nps.index';
import SLPDateQuestion from './questionsTypes/date/date.index';
import SLPRateQuestion from './questionsTypes/rate/rate.index';
import SLPSliderQuestion from './questionsTypes/slider/slider.index';
import SLPOptionsQuestion from './questionsTypes/options/options.index';
import SLPPhoneQuestion from './questionsTypes/phone/phone.index';
import SLPMobileQuestion from './questionsTypes/mobile/mobile.index';
import SLPPhotoOptionsQuestion from './questionsTypes/photoOptions/photoOptions.index';
import SLPListQuestion from './questionsTypes/list/list.index';
import SLPCameraQuestion from './questionsTypes/camera/camera.index';
import SLPFileQuestion from './questionsTypes/file/file.index';
import SLPEmojiQuestion from './questionsTypes/emoji/emoji.index';
import SLPMatrixQuestion from './questionsTypes/matrix/matrix.index';
import SLPPriorityQuestion from './questionsTypes/priority/priority.index';
import SLPStaticQuestion from './questionsTypes/static/static.index';
import SLPVoiceQuestion from './questionsTypes/voice/voice.index';
export interface QuestionSLPRef extends __QuestionSLPRef {}
export interface SLPQuestionType extends __SLPQuestionType {}

const SLPQuestion: React.ForwardRefRenderFunction<
    __QuestionSLPRef,
    ConnectedProps<typeof connector> & __SLPQuestionType
> = (props: ConnectedProps<typeof connector> & __SLPQuestionType, ref) => {
    React.useImperativeHandle(ref, () => ({
        validate: (e?: boolean) => (qRef.current ? qRef.current?.validate(e) : false),
        submit: (e?: boolean) => qRef.current?.submit(e),
    }));
    const que = props.question;
    const qRef = useRef<__QuestionSLPRef>(null);

    return (
        <div className="ucheck-slp-question-type">
            {que.input_type === QuestionTypes.simple ? (
                <SLPTextQuestion
                    answerList={props.answerList}
                    setAnswerList={props.setAnswerList}
                    submit={props.submit}
                    ref={qRef}
                    question={que}
                    answer={props.answer}
                    form={props.form}
                    next={props.next}
                    counter={props.counter}
                />
            ) : null}
            {que.input_type === QuestionTypes.number ? (
                <SLPNumberQuestion
                    answerList={props.answerList}
                    setAnswerList={props.setAnswerList}
                    submit={props.submit}
                    ref={qRef}
                    question={que}
                    answer={props.answer}
                    form={props.form}
                    next={props.next}
                    counter={props.counter}
                />
            ) : null}
            {que.input_type === QuestionTypes.email ? (
                <SLPEmailQuestion
                    answerList={props.answerList}
                    setAnswerList={props.setAnswerList}
                    submit={props.submit}
                    ref={qRef}
                    question={que}
                    answer={props.answer}
                    form={props.form}
                    next={props.next}
                    counter={props.counter}
                />
            ) : null}
            {que.input_type === QuestionTypes.website ? (
                <SLPWebsiteQuestion
                    answerList={props.answerList}
                    setAnswerList={props.setAnswerList}
                    submit={props.submit}
                    ref={qRef}
                    question={que}
                    answer={props.answer}
                    form={props.form}
                    next={props.next}
                    counter={props.counter}
                />
            ) : null}
            {que.input_type === QuestionTypes.nps ? (
                <SLPNPSQuestion
                    answerList={props.answerList}
                    setAnswerList={props.setAnswerList}
                    submit={props.submit}
                    ref={qRef}
                    question={que}
                    answer={props.answer}
                    form={props.form}
                    next={props.next}
                    counter={props.counter}
                />
            ) : null}
            {que.input_type === QuestionTypes.date ? (
                <SLPDateQuestion
                    answerList={props.answerList}
                    setAnswerList={props.setAnswerList}
                    submit={props.submit}
                    ref={qRef}
                    question={que}
                    answer={props.answer}
                    form={props.form}
                    next={props.next}
                    counter={props.counter}
                />
            ) : null}
            {que.input_type === QuestionTypes.rate ? (
                <SLPRateQuestion
                    answerList={props.answerList}
                    setAnswerList={props.setAnswerList}
                    submit={props.submit}
                    ref={qRef}
                    question={que}
                    answer={props.answer}
                    form={props.form}
                    next={props.next}
                    counter={props.counter}
                />
            ) : null}
            {que.input_type === QuestionTypes.scale ? (
                <SLPSliderQuestion
                    answerList={props.answerList}
                    setAnswerList={props.setAnswerList}
                    submit={props.submit}
                    ref={qRef}
                    question={que}
                    answer={props.answer}
                    form={props.form}
                    next={props.next}
                    counter={props.counter}
                />
            ) : null}
            {que.input_type === QuestionTypes.twoOptions || que.input_type === QuestionTypes.selective ? (
                <SLPOptionsQuestion
                    answerList={props.answerList}
                    setAnswerList={props.setAnswerList}
                    submit={props.submit}
                    ref={qRef}
                    question={que}
                    answer={props.answer}
                    form={props.form}
                    next={props.next}
                    counter={props.counter}
                />
            ) : null}
            {que.input_type === QuestionTypes.phoneNumber ? (
                <SLPPhoneQuestion
                    answerList={props.answerList}
                    setAnswerList={props.setAnswerList}
                    submit={props.submit}
                    ref={qRef}
                    question={que}
                    answer={props.answer}
                    form={props.form}
                    next={props.next}
                    counter={props.counter}
                />
            ) : null}
            {que.input_type === QuestionTypes.mobileNumber ? (
                <SLPMobileQuestion
                    answerList={props.answerList}
                    setAnswerList={props.setAnswerList}
                    submit={props.submit}
                    ref={qRef}
                    question={que}
                    answer={props.answer}
                    form={props.form}
                    next={props.next}
                    counter={props.counter}
                />
            ) : null}
            {que.input_type === QuestionTypes.pictureSelective ? (
                <SLPPhotoOptionsQuestion
                    answerList={props.answerList}
                    setAnswerList={props.setAnswerList}
                    submit={props.submit}
                    ref={qRef}
                    question={que}
                    answer={props.answer}
                    form={props.form}
                    next={props.next}
                    counter={props.counter}
                />
            ) : null}
            {que.input_type === QuestionTypes.dropDown ? (
                <SLPListQuestion
                    answerList={props.answerList}
                    setAnswerList={props.setAnswerList}
                    submit={props.submit}
                    ref={qRef}
                    question={que}
                    answer={props.answer}
                    form={props.form}
                    next={props.next}
                    counter={props.counter}
                />
            ) : null}
            {que.input_type === QuestionTypes.camera ? (
                <SLPCameraQuestion
                    answerList={props.answerList}
                    setAnswerList={props.setAnswerList}
                    submit={props.submit}
                    ref={qRef}
                    question={que}
                    answer={props.answer}
                    form={props.form}
                    next={props.next}
                    counter={props.counter}
                />
            ) : null}
            {que.input_type === QuestionTypes.emoji ? (
                <SLPEmojiQuestion
                    answerList={props.answerList}
                    setAnswerList={props.setAnswerList}
                    submit={props.submit}
                    ref={qRef}
                    question={que}
                    answer={props.answer}
                    form={props.form}
                    next={props.next}
                    counter={props.counter}
                />
            ) : null}
            {que.input_type === QuestionTypes.file ? (
                <SLPFileQuestion
                    answerList={props.answerList}
                    setAnswerList={props.setAnswerList}
                    submit={props.submit}
                    ref={qRef}
                    question={que}
                    answer={props.answer}
                    form={props.form}
                    next={props.next}
                    counter={props.counter}
                />
            ) : null}
            {que.input_type === QuestionTypes.priority ? (
                <SLPPriorityQuestion
                    answerList={props.answerList}
                    setAnswerList={props.setAnswerList}
                    submit={props.submit}
                    ref={qRef}
                    question={que}
                    answer={props.answer}
                    form={props.form}
                    next={props.next}
                    counter={props.counter}
                />
            ) : null}
            {que.input_type === QuestionTypes.matrix ? (
                <SLPMatrixQuestion
                    answerList={props.answerList}
                    setAnswerList={props.setAnswerList}
                    submit={props.submit}
                    ref={qRef}
                    question={que}
                    answer={props.answer}
                    form={props.form}
                    next={props.next}
                    counter={props.counter}
                />
            ) : null}
            {que.input_type === QuestionTypes.static ? (
                <SLPStaticQuestion
                    answerList={props.answerList}
                    setAnswerList={props.setAnswerList}
                    submit={props.submit}
                    ref={qRef}
                    question={que}
                    answer={props.answer}
                    form={props.form}
                    next={props.next}
                    counter={props.counter}
                />
            ) : null}
            {que.input_type === QuestionTypes.voice ? (
                <SLPVoiceQuestion
                    answerList={props.answerList}
                    setAnswerList={props.setAnswerList}
                    ref={qRef}
                    question={que}
                    answer={props.answer}
                    form={props.form}
                    next={props.next}
                    counter={props.counter}
                    submit={props.submit}
                />
            ) : null}
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    direction: state.direction,
    lang: state.lang,
});

const connector = connect(mapStateToProps, null, null, { forwardRef: true });
export default connector(React.forwardRef(SLPQuestion));
